import { render, staticRenderFns } from "./Form519.vue?vue&type=template&id=20676123&scoped=true&"
import script from "./Form519.vue?vue&type=script&lang=js&"
export * from "./Form519.vue?vue&type=script&lang=js&"
import style0 from "./Form519.vue?vue&type=style&index=0&id=20676123&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20676123",
  null
  
)

export default component.exports